import { FC } from 'react';
import { GqlError } from '@/typings/graphql';
import { useTranslation } from 'react-i18next';
import { SerializedError } from '@reduxjs/toolkit';

export const ErrorToast: FC<{
  error?:
    | string
    | GqlError
    | SerializedError
    | Error
    | { name?: string; message?: string; code?: string | number };
}> = ({ error }) => {
  const { t } = useTranslation();
  const rawMessage = typeof error === 'string' ? error : error?.message;
  const errorMessage = rawMessage?.trim() || t('error.generic.toast.default');
  const errorCode =
    typeof error !== 'string' && error && 'code' in error
      ? error.code
      : undefined;

  const errorName =
    typeof error !== 'string' && error?.name
      ? `${error.name} ${errorCode !== undefined ? ` (${errorCode})` : ''}`
      : t('error.generic.toast.contact');

  const showErrorDetails = typeof error !== 'string'; // Error details are shown only if it's not a simple string message (e.g., some errors are thrown from the frontend itself)

  return (
    <div className="flex flex-col gap-1">
      <div className="text-sm">{errorMessage}</div>
      {showErrorDetails && (
        <div className="text-xs text-gray-500">{errorName}</div>
      )}
    </div>
  );
};
